module.exports = __webpack_public_path__ + "static/media/gallerium.277db192.png";